'use strict';

import reqwest from "reqwest";
import settings from "./settings";
var parseString = require('xml2js').parseString;
import instafeed from 'instafeed.js';
import Promise from 'promise';

export default {

    login: (creds) => {
        return new Promise((resolve, reject) => {

            if (!creds || typeof creds.un == 'undefined' || !creds.un || typeof creds.pw === 'undefined' || !creds.pw) {
                reject('both username and password are required');
            } else {

                reqwest({
                    //url: ('/functions/artezlogin'),
                    url: (settings.baseURI + '/artez/login'),
                    type: 'json',
                    method: 'POST',
                    data: JSON.stringify(creds),
                    headers: {
                        'x-functions-key': 'EaJVkJtIMAppw0q1xGFdlkBz7tIyLervPMZ3saPYhVLLquNckBMJ2Q==',
                        'cache-control': 'no-cache'
                    },
                    error: (err) => {
                        console.info(err);
                        if (err.status === 404) {
                            reject('Login failed');
                        } else {
                            reject('there was an error');
                        }
                    },
                    success: (resp) => {
                        console.info(resp);
                        resolve(resp);
                    }
                })
            }
        })
    },

    forgotPassword: (user) => {
        return new Promise((resolve, reject) => {

            if (!settings || !settings.EventID) {
                reject('no event id mapped');
            } else if (!user || typeof user.UserName === 'undefined' || !user.UserName) {
                reject('no username received');
            } else {
                user.EventID = settings.EventID;
                reqwest({
                    //url: ('/functions/artezlogin'),
                    url: (settings.baseURI + '/artez/forgotpassword'),
                    type: 'json',
                    method: 'POST',
                    data: JSON.stringify(user),
                    headers: {
                        'x-functions-key': 'IHrSaqtdN2FS7P1qWTPfenrblg87YZY4CsmFE7qJ9DHPRaSZ4/RmHQ==',
                        'cache-control': 'no-cache'
                    },
                    error: (err) => {
                        console.info(err);
                        if (err.status === 404) {
                            reject('username not found');
                        } else {
                            reject('there was an error');
                        }
                    },
                    success: (resp) => {
                        console.info(resp);
                        resolve(resp);
                    }
                })
            }
        })
    },


    forgotUsername: (user) => {
        return new Promise((resolve, reject) => {

            if (!settings || !settings.EventID) {
                reject('no event id mapped');
            } else if (!user || typeof user.EmailAddress === 'undefined' || !user.EmailAddress) {
                reject('no username received');
            } else {
                user.EventID = settings.EventID;
                reqwest({
                    //url: ('/functions/artezlogin'),
                    url: (settings.baseURI + '/artez/forgotusername'),
                    type: 'json',
                    method: 'POST',
                    data: JSON.stringify(user),
                    headers: {
                        'x-functions-key': 'vSfgOE21liLLYCBGkJdWVyBqLBaMLsWs0gefcaWklS2ZJOjssJ7NfA==',
                        'cache-control': 'no-cache'
                    },
                    error: (err) => {
                        console.info(err);
                        if (err.status === 404) {
                            reject('user not found');
                        } else {
                            reject('there was an error');
                        }
                    },
                    success: (resp) => {
                        console.info(resp);
                        resolve(resp);
                    }
                })
            }
        })
    },

    fetchIndividualLeaderboardData: () => {
        return new Promise((resolve, reject) => {
            if (!settings || !settings.EventID) {
                reject('no event id mapped');
            } else {
                // var url = `https://secure.artezpacific.com/webgetservice/get.asmx/getParticipantScoreBoard?eventID=${settings.EventID}&${settings.languageCode}&${settings.sortBy}&${settings.listItemCount}&externalQuestionID=&externalAnswerID=&Source=`;
                var url = `https://cancerqld.org.au/engine/wp-admin/admin-ajax.php`;
                reqwest({
                    url: (url),
                    method: 'POST',
                    data: { action: 'wfwc_scoreboard01' },
                    // headers: {
                    //     'cache-control': 'no-cache'
                    // },
                    crossOrigin: true,
                    error: (err) => {
                        console.info(err);
                        if (err.status === 404) {
                            reject('Leaderboard not found');
                        } else {
                            reject('There was an error');
                        }
                    },
                    success: (resp) => {
                        // console.info(resp);
                        var json = resp;
                        // parseString(resp, function (err, result) {
                        //     // console.dir(result);
                        //     json = JSON.stringify(result);
                        // });

                        resolve(json);
                    }
                })
            }
        })
    },
    fetchTeamLeaderboardData: () => {
        return new Promise((resolve, reject) => {
            if (!settings || !settings.EventID) {
                reject('no event id mapped');
            } else {
                // var url = `https://secure.artezpacific.com/webgetservice/get.asmx/getTeamScoreBoard?eventID=${settings.EventID}&${settings.languageCode}&${settings.sortBy}&${settings.listItemCount}&externalQuestionID=&externalAnswerID=&Source=`;
                var url = `https://cancerqld.org.au/engine/wp-admin/admin-ajax.php`;
                reqwest({
                    url: (url),
                    method: 'POST',
                    data: { action: 'wfwc_scoreboard02' },
                    // headers: {
                    //     'cache-control': 'no-cache'
                    // },
                    crossOrigin: true,
                    error: (err) => {
                        console.info(err);
                        if (err.status === 404) {
                            reject('Leaderboard not found');
                        } else {
                            reject('There was an error');
                        }
                    },
                    success: (resp) => {
                        // console.info(resp);
                        var json = resp;
                        // parseString(resp, function (err, result) {
                        //     // console.dir(result);
                        //     json = JSON.stringify(result);
                        // });

                        resolve(json);
                    }
                })
            }
        })
    },
    getWordpressStories: () => {
        return new Promise((resolve, reject) => {
            var url = `https://cancerqld.org.au/wp-json/wp/v2/posts?_embed&categories=${settings.wordpressPostID}`;
            reqwest({
                url: (url),
                method: 'GET',
                headers: {
                    // 'cache-control': 'no-cache'
                },
                crossOrigin: true,
                error: (err) => {
                    console.info(err);
                    if (err.status === 404) {
                        reject('Leaderboard not found');
                    } else {
                        reject('There was an error');
                    }
                },
                success: (resp) => {

                    resolve(resp);
                }
            }) 
        })
    },
    getInstagramFeed: () => {
        return new Promise((resolve, reject) => {
            // let feed = new instafeed({
            //     get: 'tagged',
            //     tagName: 'awesome',
            //     clientId: settings.instagramClientID,
            //     limit: 6
            // })
            // feed.run()
            resolve('Hi')
        })
    }
}


// WEBPACK FOOTER //
// ./src/js/requests.js